/**
 * Shared utilities for {@link ActivityTypeRow}, {@link ActivityTypeCard} and {@link ActivityTypesDataTable}.
 */
import { ACTIVITY_TYPE_STATUS_CONFIG, type ActivityTypeFilters } from './activity-type-configs';
import type { ActivityType } from '@/types/activity-type.types';

/**
 * Returns the status config for an activity type.
 * Shared between {@link ActivityTypeCard} and {@link ActivityTypeRow} to avoid the duplicate lookup.
 */
export function getActivityTypeStatusConfig(activityType: ActivityType) {
  return ACTIVITY_TYPE_STATUS_CONFIG[activityType.status];
}

/** Map UI filters + pagination to activity-type list params. */
export function toActivityTypeListParams(
  filters: ActivityTypeFilters,
  page: number,
  pageSize: number,
): {
  page: number;
  pageSize: number;
  statuses?: ActivityTypeFilters['statuses'];
  search?: string;
} {
  return {
    page,
    pageSize,
    statuses: filters.statuses.length > 0 ? filters.statuses : undefined,
    search: filters.searchQuery,
  };
}

/** True when any status chip or search query is set. */
export function hasActivityTypeActiveFilters(filters: ActivityTypeFilters): boolean {
  return filters.statuses.length > 0 || !!filters.searchQuery?.trim();
}
